var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main-content" }, [
      _c("div", { attrs: { id: "boxloading" } }),
      _vm._v(" "),
      _c("div", { staticClass: "main-content-inner" }, [
        _c(
          "div",
          {
            staticClass: "breadcrumbs ace-save-state",
            attrs: { id: "breadcrumbs" }
          },
          [
            _c(
              "ul",
              { staticClass: "breadcrumb" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "router-link",
                  { attrs: { tag: "li", to: { name: "user" } } },
                  [_c("a", [_vm._v("ユーザー")])]
                ),
                _vm._v(" "),
                _c("li", { staticClass: "active" }, [
                  _vm._v("新規ユーザー登録")
                ])
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "page-content register_user" }, [
          _vm.loading
            ? _c("div", { attrs: { id: "loading" } }, [
                _c("div", { staticClass: "loadingMsg" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _vm.message &&
            _vm.GroupIdSubmittedFail.length === 0 &&
            _vm.PcodeSubmittedFail.length == 0 &&
            _vm.sucessStatus
              ? _c("div", { staticClass: "alert alert-success" }, [
                  _vm._v(
                    "\n            " + _vm._s(_vm.message) + "\n          "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.errorMessageLogs !== ""
              ? _c("div", { staticClass: "alert alert-danger" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.errorMessageLogs) +
                      "\n          "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.GroupIdSubmittedFail.length > 0 &&
            _vm.PcodeSubmittedFail.length === 0 &&
            _vm.sucessStatus
              ? _c("div", { staticClass: "alert alert-danger" }, [
                  _vm._v(
                    "\n            ユーザーは登録されましたが、ゲートグループの紐づけに失敗しています。"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n            ユーザー編集より、ゲートグループの確認をしてください。\n          "
                  )
                ])
              : _vm.GroupIdSubmittedFail.length === 0 &&
                _vm.PcodeSubmittedFail.length > 0 &&
                _vm.sucessStatus
                ? _c("div", { staticClass: "alert alert-danger" }, [
                    _vm._v(
                      "\n            ユーザーは登録されましたが、個人コードの紐づけに失敗しています。"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n            ユーザー編集より、個人コードの確認をしてください。\n          "
                    )
                  ])
                : _vm.GroupIdSubmittedFail.length > 0 &&
                  _vm.PcodeSubmittedFail.length > 0 &&
                  _vm.sucessStatus
                  ? _c("div", { staticClass: "alert alert-danger" }, [
                      _vm._v(
                        "\n            ユーザーは登録されましたが、ゲートグループと個人コードの紐づけに失敗しています。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            ユーザー編集より、ゲートグループと個人コードの確認をしてください。\n          "
                      )
                    ])
                  : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-sm-10" }, [
                _c("div", { staticClass: "profile-user-info" }, [
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c(
                      "div",
                      { staticClass: "profile-info-name" },
                      [
                        _vm._v("ユーザーID "),
                        _c("font", { staticClass: "input-required" }, [
                          _vm._v("※必須")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "userid_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.userId,
                            expression: "userInfor.userId"
                          }
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          placeholder: "ユーザーID",
                          id: "userid",
                          type: "text",
                          name: "userId"
                        },
                        domProps: { value: _vm.userInfor.userId },
                        on: {
                          blur: function($event) {
                            _vm.validateBeforeSubmit(1)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "userId",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c(
                      "div",
                      { staticClass: "profile-info-name" },
                      [
                        _vm._v("ログインパスワード "),
                        _c("font", { staticClass: "input-required" }, [
                          _vm._v("※必須")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("label", { staticClass: "clearfix cusrow" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "password_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.password,
                            expression: "userInfor.password"
                          }
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          id: "password",
                          placeholder: "パスワード",
                          name: "password",
                          type: "password"
                        },
                        domProps: { value: _vm.userInfor.password },
                        on: {
                          blur: function($event) {
                            _vm.validateBeforeSubmit(2)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "password",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "newpassword-showhide" }, [
                      _c(
                        "span",
                        {
                          staticClass: "show-password",
                          on: {
                            click: function($event) {
                              _vm.showhidePassword(
                                "password",
                                "show-password",
                                "newpassword-showhide"
                              )
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../../static/img/eye_off.png"),
                              width: "30"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "hide-password",
                          on: {
                            click: function($event) {
                              _vm.showhidePassword(
                                "password",
                                "hide-password",
                                "newpassword-showhide"
                              )
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../../static/img/eye_on.png"),
                              width: "30"
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "warringu" }, [
                      _vm._v(
                        "\n                    ログインパスワードは英大文字、英小文字、数字を組み合わせた8文字以上64文字以内で設定してください。\n                  "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c(
                      "div",
                      { staticClass: "profile-info-name" },
                      [
                        _vm._v("ユーザー名（登録名）"),
                        _c("font", { staticClass: "input-required" }, [
                          _vm._v("※必須")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "name_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.name,
                            expression: "userInfor.name"
                          }
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          type: "text",
                          id: "name",
                          placeholder: "ユーザー名"
                        },
                        domProps: { value: _vm.userInfor.name },
                        on: {
                          blur: function($event) {
                            _vm.validateBeforeSubmit(3)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.userInfor, "name", $event.target.value)
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("ユーザー名（ふりがな）")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "furigana_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.furigana,
                            expression: "userInfor.furigana"
                          }
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          type: "text",
                          id: "furigana",
                          placeholder: "ふりがな"
                        },
                        domProps: { value: _vm.userInfor.furigana },
                        on: {
                          blur: function($event) {
                            _vm.validateBeforeSubmit(4)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "furigana",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("メールアドレス")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "mailaddress_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.email,
                            expression: "userInfor.email"
                          }
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          type: "text",
                          id: "mailaddress",
                          placeholder: "example@example.com"
                        },
                        domProps: { value: _vm.userInfor.email },
                        on: {
                          blur: function($event) {
                            _vm.validateBeforeSubmit(5)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "email",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("暗証番号")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "passcode_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.passCode,
                            expression: "userInfor.passCode"
                          }
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          type: "text",
                          id: "passcode",
                          placeholder: "0000"
                        },
                        domProps: { value: _vm.userInfor.passCode },
                        on: {
                          blur: function($event) {
                            _vm.validateBeforeSubmit(6)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "passCode",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("組織管理権限")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.isAdmin,
                            expression: "userInfor.isAdmin"
                          }
                        ],
                        staticClass: "ace ace-switch ace-switch-4",
                        attrs: { name: "switch-field-1", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.userInfor.isAdmin)
                            ? _vm._i(_vm.userInfor.isAdmin, null) > -1
                            : _vm.userInfor.isAdmin
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.userInfor.isAdmin,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.userInfor.isAdmin = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.userInfor.isAdmin = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(_vm.userInfor, "isAdmin", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "lbl" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("ゲート設定権限")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.isPhoneAdmin,
                            expression: "userInfor.isPhoneAdmin"
                          }
                        ],
                        staticClass: "ace ace-switch ace-switch-4",
                        attrs: { name: "switch-field-1", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.userInfor.isPhoneAdmin)
                            ? _vm._i(_vm.userInfor.isPhoneAdmin, null) > -1
                            : _vm.userInfor.isPhoneAdmin
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.userInfor.isPhoneAdmin,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.userInfor.isPhoneAdmin = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.userInfor.isPhoneAdmin = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(_vm.userInfor, "isPhoneAdmin", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "lbl" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("鍵共有権限")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.shareKeyBeValid,
                            expression: "userInfor.shareKeyBeValid"
                          }
                        ],
                        staticClass: "ace ace-switch ace-switch-4",
                        attrs: { name: "switch-field-1", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.userInfor.shareKeyBeValid)
                            ? _vm._i(_vm.userInfor.shareKeyBeValid, null) > -1
                            : _vm.userInfor.shareKeyBeValid
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.userInfor.shareKeyBeValid,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.userInfor.shareKeyBeValid = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.userInfor.shareKeyBeValid = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(_vm.userInfor, "shareKeyBeValid", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "lbl" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("ステータス")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.isValid,
                            expression: "userInfor.isValid"
                          }
                        ],
                        staticClass: "ace ace-switch ace-switch-4",
                        attrs: { name: "switch-field-1", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.userInfor.isValid)
                            ? _vm._i(_vm.userInfor.isValid, null) > -1
                            : _vm.userInfor.isValid
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.userInfor.isValid,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.userInfor.isValid = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.userInfor.isValid = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(_vm.userInfor, "isValid", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "lbl" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("ゲートグループ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "profile-info-value" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "error_m",
                            attrs: { id: "pcode_error" }
                          },
                          [_vm._v(_vm._s(_vm.gateGroupErrorMessage))]
                        ),
                        _vm._v(" "),
                        _c("user-gate-group-select", {
                          attrs: {
                            id: "group-selection-container",
                            userId: _vm.userId,
                            startAddGroup: _vm.startAddGroup,
                            loading: _vm.loading,
                            gateGroupErrorMessage: _vm.gateGroupErrorMessage,
                            isFinishGetDataGroup: _vm.isFinishGetDataGroup,
                            isFinishAddGroup: _vm.isFinishAddGroup,
                            GroupIdSubmittedFail: _vm.GroupIdSubmittedFail,
                            resetDataGroupPcode: _vm.resetDataGroupPcode
                          },
                          on: {
                            "update:loading": function($event) {
                              _vm.loading = $event
                            },
                            "update:gateGroupErrorMessage": function($event) {
                              _vm.gateGroupErrorMessage = $event
                            },
                            "update:isFinishGetDataGroup": function($event) {
                              _vm.isFinishGetDataGroup = $event
                            },
                            "update:isFinishAddGroup": function($event) {
                              _vm.isFinishAddGroup = $event
                            },
                            "update:GroupIdSubmittedFail": function($event) {
                              _vm.GroupIdSubmittedFail = $event
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "profile-info-name",
                        staticStyle: { "vertical-align": "top" }
                      },
                      [_vm._v("個人コード")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "profile-info-value" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "error_m",
                            attrs: { id: "pcode_error" }
                          },
                          [_vm._v(_vm._s(_vm.pcodeErrorMessage))]
                        ),
                        _vm._v(" "),
                        _c("app-user-pcode-select", {
                          attrs: {
                            id: "pcode-selection-container",
                            assignedPcode: _vm.assignedPcode,
                            pcodeErrorMessage: _vm.pcodeErrorMessage,
                            PcodeSubmittedFail: _vm.PcodeSubmittedFail,
                            isPCodeFinishGet: _vm.isPCodeFinishGet,
                            isPcodeFinishAdd: _vm.isPcodeFinishAdd,
                            userId: _vm.userInfor.userId,
                            loading: _vm.loading,
                            startAddPcode: _vm.startAddPcode,
                            resetDataGroupPcode: _vm.resetDataGroupPcode
                          },
                          on: {
                            "update:assignedPcode": function($event) {
                              _vm.assignedPcode = $event
                            },
                            "update:pcodeErrorMessage": function($event) {
                              _vm.pcodeErrorMessage = $event
                            },
                            "update:PcodeSubmittedFail": function($event) {
                              _vm.PcodeSubmittedFail = $event
                            },
                            "update:isPCodeFinishGet": function($event) {
                              _vm.isPCodeFinishGet = $event
                            },
                            "update:isPcodeFinishAdd": function($event) {
                              _vm.isPcodeFinishAdd = $event
                            },
                            "update:loading": function($event) {
                              _vm.loading = $event
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("SMS認証")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.isMfaSms,
                            expression: "userInfor.isMfaSms"
                          }
                        ],
                        staticClass: "ace ace-switch ace-switch-4",
                        attrs: {
                          name: "switch-field-1",
                          type: "checkbox",
                          disabled: _vm.isMfa === "false"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.userInfor.isMfaSms)
                            ? _vm._i(_vm.userInfor.isMfaSms, null) > -1
                            : _vm.userInfor.isMfaSms
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.userInfor.isMfaSms,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.userInfor.isMfaSms = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.userInfor.isMfaSms = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(_vm.userInfor, "isMfaSms", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "lbl" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("電話番号")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "phonenumber_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.phoneNumber,
                            expression: "userInfor.phoneNumber"
                          }
                        ],
                        staticClass: "form-control input-sm input",
                        attrs: {
                          type: "text",
                          id: "phonenumber",
                          placeholder: "",
                          disabled: !_vm.isSMS
                        },
                        domProps: { value: _vm.userInfor.phoneNumber },
                        on: {
                          blur: function($event) {
                            _vm.validateBeforeSubmit(9)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "phoneNumber",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("p", { staticStyle: { "margin-top": "10px" } }, [
                        _vm._v(
                          "0から始まる-(ハイフン)無しの携帯電話番号を11桁で入力してください。"
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("備考.1")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "option1_error" }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.option1,
                            expression: "userInfor.option1"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "option1", placeholder: "備考.1" },
                        domProps: { value: _vm.userInfor.option1 },
                        on: {
                          blur: function($event) {
                            _vm.validateBeforeSubmit(7)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "option1",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("備考.2")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "option2_error" }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.option2,
                            expression: "userInfor.option2"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "option2", placeholder: "備考.2" },
                        domProps: { value: _vm.userInfor.option2 },
                        on: {
                          blur: function($event) {
                            _vm.validateBeforeSubmit(8)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "option2",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12" }, [
                    _c(
                      "div",
                      { staticClass: "action_box" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "btn cancel_bottom",
                            attrs: { to: { name: "user" } }
                          },
                          [
                            _vm._v(
                              "\n                      キャンセル\n                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-info save_bottom",
                            attrs: { type: "button" },
                            on: { click: _vm.pCodeChangeConfirm }
                          },
                          [
                            _vm._v(
                              "\n                      ユーザーを登録\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "pCode-change", tabindex: "-1" }
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("span", { staticClass: "progress-question" }, [
                _vm._v(
                  "以下の個人コードの関連付けユーザーが変更されますがよろしいでしょうか？"
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "error-box",
                    staticStyle: { "margin-top": "20px" }
                  },
                  [
                    _vm._l(_vm.assignedPcode, function(item) {
                      return [
                        _c(
                          "p",
                          { key: item.pCodeId },
                          [
                            _vm._v("ユーザーID："),
                            _c("font", { staticStyle: { color: "red" } }, [
                              _vm._v(_vm._s(item.userId))
                            ]),
                            _vm._v("に関連付けされた個人コード”"),
                            _c("font", { staticStyle: { color: "red" } }, [
                              _vm._v(_vm._s(item.pCodeId))
                            ]),
                            _vm._v("”の関連付けユーザーが変更されます。")
                          ],
                          1
                        )
                      ]
                    })
                  ],
                  2
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm",
                  staticStyle: { width: "100px" },
                  attrs: { "data-dismiss": "modal" }
                },
                [_vm._v("キャンセル")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-success",
                  staticStyle: { width: "100px" },
                  attrs: { "data-dismiss": "modal" },
                  on: { click: _vm.submitAddUser }
                },
                [_vm._v("OK")]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal fade", attrs: { id: "question", tabindex: "-1" } },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-success",
                  staticStyle: { width: "100px" },
                  attrs: { "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.yesChoice()
                    }
                  }
                },
                [_vm._v("送信する")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm",
                  staticStyle: { width: "100px" },
                  attrs: { "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.noChoice()
                    }
                  }
                },
                [_vm._v("送信しない")]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
      _vm._v(" "),
      _c("a", { attrs: { href: "#/" } }, [_vm._v("メインメニュー")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [
        _c("h3", [_vm._v("新規ユーザー登録")])
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticStyle: { display: "none" },
          attrs: { href: "#question", id: "confirm", "data-toggle": "modal" }
        },
        [_vm._v("show")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-12 col-sm-2 center userav" }, [
      _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
        _c("span", { staticClass: "profile-picture" }, [
          _c("img", {
            staticClass: "editable img-responsive",
            staticStyle: { width: "150px", height: "150px", overflow: "auto" },
            attrs: {
              id: "user_avatar",
              alt: "user avatar",
              src: require("../../../static/images/avatars/default-avatar.png"),
              width: "150",
              height: "150"
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
        _c(
          "label",
          {
            staticClass: "btn-upload",
            staticStyle: {
              background: "black",
              color: "white",
              padding: "5px 15px",
              "margin-top": "10px",
              cursor: "pointer"
            },
            attrs: { for: "file_user_avatar" }
          },
          [
            _vm._v(
              "\n                  画像ファイルを選択\n                  "
            ),
            _c("input", {
              staticStyle: { display: "none" },
              attrs: {
                type: "file",
                name: "avatar",
                id: "file_user_avatar",
                accept: "image/png"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "error_m", attrs: { id: "fileimg_error" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "smaller lighter frofile-title no-margin" }, [
        _vm._v("個人コードの関連付けユーザー")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("div", [
        _vm._v(
          "\n            作成したユーザーのメールアドレスへ通知メールを送信しますか？\n          "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ab9668c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab9668c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/UserAdd.vue
// module id = null
// module chunks = 